import { i18n, localized } from "@msuite/ui/localization";
import type { TranslationKey } from "@msuite/utils/locales";
import { snakeCase } from "@msuite/utils/strings";

/**
 * The manifest is the source of truth for what a permission grid renders, and the locale file is
 * a second file that has to keep up with it. A subject or action added to the manifest before its
 * key exists reads as itself — `Ticket`, `approve` — rather than as a raw key path, which is
 * the one failure mode a translated grid can have that the untranslated one could not.
 */
function localizedOrRaw(key: string, raw: string): string {
	if (!i18n.exists(key)) return raw;
	return localized(key as TranslationKey);
}

/**
 * The label of one manifest subject — the row header of a permission grid.
 */
export function localizedSubject(subject: string): string {
	return localizedOrRaw(`permissions.subjects.${snakeCase(subject)}`, subject);
}

/**
 * The label of one manifest action — a column header of a permission grid.
 */
export function localizedAction(action: string): string {
	return localizedOrRaw(`permissions.actions.${snakeCase(action)}`, action);
}
